import tw, { styled } from 'twin.macro'

export const TableCell = styled.td(({ hideOnMobile }) => [
  tw`px-2 md:px-6 py-4 whitespace-nowrap table-cell md:table-cell`,
  hideOnMobile && tw`hidden`,
])
